module.exports = __webpack_public_path__ + "static/img/cq.dc45700b.svg";